<template lang="pug">
  div
    v-toolbar(fixed app color="white" height="60px" flat style="border-bottom: 1px solid #e8e8e8 !important; z-index: 4;" id="layoutTopBar")
      v-layout(wrap)
        v-flex(xs12)
          v-layout(fluid style="margin: 0" align-center)
            v-btn.side-icon(icon @click="sideIconEvent" style="width: 45px;" dark)
              .icon-menu
                .bar
                .bar
                .bar
            v-toolbar-title.black--text
              v-breadcrumbs(large)
                v-icon(slot="divider" light) chevron_right
                v-breadcrumbs-item(v-for="(item, index) in $route.meta.breadcrumb" :key="item.title")
                  span(:class="(index === $route.meta.breadcrumb.length - 1) ? 'grey--text' : 'black--text'") {{ item.title }}
            v-spacer
            span(style="white-space: nowrap" v-if="devMode") 剩餘{{logoutCounter}}秒
            notification(:show.sync="notificationMenu")
            v-btn.mr-3(outline @click="doLogout" color="grey darken-1" small style="min-width: 60px;") 登出
        v-flex(xs12)
          v-progress-linear.ma-0(color="achYellow2" background-color="white" height="3" style="bottom: 2px;" :indeterminate="barLoadingStatus")
    v-navigation-drawer(
    dark
    v-model="navDrawer"
    app
    mobile-break-point="1px"
    style="z-index: 5"
    :disable-route-watcher="true"
    id="sideMenu"
    :width="280")
      .white--text.px-4(style="word-break: break-all")
        v-layout.my-3(column align-center)
          v-avatar.white(size="85px")
            v-img(:src="brandLogo")
          span.title.my-2 {{groupInfo}}
          span.body-1.mb-2 {{storeInfo.user.name}}
          span(v-if="envParams" style="font-size: 12px; transform: scale(0.9)") {{envParams}}
      v-divider
      sideMenu
    v-content(v-resize="windowSize" id="mainContent")
      template(v-if="initFinish")
        transition(name="slide-fade" mode="out-in" appear)
          router-view
    appFooter
</template>

<script>
import sideMenu from 'views/portal/layout/components/SideMenu'
import notification from 'views/portal/layout/components/Notification'
import appFooter from 'views/portal/layout/components/AppFooter'
import { global } from 'mixins/global'

export default {
  mixins: [global],
  data () {
    return {
      navDrawer: false,
      isSmallSize: false,
      notificationMenu: false,
      fab: false,
      initFinish: false,
      timer: null,
      logoutCounter: 3600
    }
  },
  components: {
    sideMenu,
    notification,
    appFooter
  },
  computed: {
    envParams () {
      let env = this.$store.getters.getEnvParams
      return (env) ? env.envMode + '-' + env.version : null
    },
    barLoadingStatus () {
      return this.$store.getters.getPageLoadingStatus
    }
  },
  created () {
    // 登入成功or重整頁面，取得初始化資料
    this.initAllData()
  },
  mounted () {
     gapi.load('auth2', function(){
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      auth2 = gapi.auth2.init({
        client_id: process.env.google_client_id || '210824251723-9vt2bl9jmso4bg536rpv7dl1opdi7ajm.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        // Request scopes in addition to 'profile' and 'email'
        //scope: 'additional_scope'
      });
    });
    this.navDrawer = !(window.innerWidth < 1024)
    window.dispatchEvent(new Event('resize'))
    window.addEventListener('mousemove', this.$__counterHandler)
    window.addEventListener('mousedown', this.$__counterHandler)
    window.addEventListener('wheel', this.$__counterHandler)
    this.calculateLogout()





  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.$__counterHandler)
    window.removeEventListener('mousedown', this.$__counterHandler)
    window.removeEventListener('wheel', this.$__counterHandler)
    clearTimeout(this.timer)
  },
  methods: {
    calculateLogout () {
      this.logoutCounter--
      if (this.logoutCounter <= 0) {
        this.$store.dispatch('cleanLoginInfo')
        this.$store.commit('SET_MODAL_STATUS', {status: true, type: 'info', title: 'errors.authKickOut', subTitle: 'errors.over1hr', btnLink: '/login'})
        clearTimeout(this.timer)
      } else {
        this.timer = setTimeout(this.calculateLogout, 1000)
      }
    },
    doLogout () {
      let auth2 = gapi.auth2.getAuthInstance()
      auth2.signOut().then(function () {
       console.log('User signed out from layout');
     });
     
      this.$store.dispatch('cleanLoginInfo')
      this.$router.push('/login')
    },
    sideIconEvent () {
      this.navDrawer = !this.navDrawer
      this.closeNotification()
    },
    windowSize () {
      this.isSmallSize = (window.innerWidth < 1024)
    },
    closeNotification () {
      this.notificationMenu = false
    },
    $__counterHandler () {
      this.logoutCounter = 3600
    },
    initAllData () {
      this.$store.commit('SET_LOADING_STATUS', true)
      // 在此重新讀取初始化所需要的資訊
  
          // 登入者資訊
          this.$store.dispatch('fetchUserInfo')
            .then(user => {
              this.$store.dispatch('fetchGroups', {params: {userId: user.data.id}})
              // 訊息通知
              this.$store.dispatch('fetchNotifications', {params: {userId: user.data.id}})
               // 付款方式合約細節
              this.$store.dispatch('fetchPaymentsContract')
              // 商家資訊
              this.$store.dispatch('fetchStoreInfo', {params: {brandId: user.data.brandId}})
                .then(() => {
                  this.$store.commit('SET_LOADING_STATUS', false)
                  this.initFinish = true
                })
            })
       
    }
  },
  watch: {
    'isSmallSize' (value) {
      this.navDrawer = !value
    },
    '$route' () {
      this.closeNotification()
      if (this.isSmallSize) this.navDrawer = false
      // 捲軸 置頂
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="sass" scoped>
  .side-icon:hover .bar:after
    right: 0

  .icon-menu
    position: relative
    display: inline-block
    width: 15px
    height: 13px

    .bar
      position: absolute
      height: 2px
      background-color: #000
      overflow: hidden

      &:after
        content: ''
        display: block
        width: 100%
        height: 100%
        background: #feaa00
        position: absolute
        top: 0
        right: 100%
        z-index: 1
        -webkit-transition: 0.3s
        transition: 0.3s

      &:nth-child(1)
        top: 0
        width: 15px

        &:hover
          left: 0

        &:after
          -webkit-transition-delay: 0.1s
          transition-delay: 0.1s

      &:nth-child(2)
        top: 5px
        width: 15px
        &:after
          -webkit-transition-delay: 0.2s
          transition-delay: 0.2s

      &:nth-child(3)
        top: 10px
        width: 15px
        &:after
          -webkit-transition-delay: 0.3s
          transition-delay: 0.3s

  #app /deep/
    .tooltip
      margin-right: 15px

  @media only screen and (max-width: 599px)
    #app /deep/
      .notification-menu
        .menu-arrow
          right: 85px

  .slide-fade-enter-active
    transition: all .4s ease

  .slide-fade-leave-active
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .slide-fade-enter-to
  .slide-fade-enter, .slide-fade-leave-active
    transform: translateY(-30px)
    opacity: 0

  #layoutTopBar /deep/
    .v-toolbar__content
      padding: 0
</style>
